import { render, staticRenderFns } from "./HistoryOfChangesComponent.vue?vue&type=template&id=5f6c44c2&scoped=true"
import script from "./HistoryOfChangesComponent.vue?vue&type=script&lang=js"
export * from "./HistoryOfChangesComponent.vue?vue&type=script&lang=js"
import style0 from "./HistoryOfChangesComponent.vue?vue&type=style&index=0&id=5f6c44c2&prod&scoped=true&lang=css"
import style1 from "./HistoryOfChangesComponent.vue?vue&type=style&index=1&id=5f6c44c2&prod&media=print&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c44c2",
  null
  
)

export default component.exports